__turbopack_context__.v({
  "calloutSection": "CDuwya_calloutSection",
  "contactModal": "CDuwya_contactModal",
  "footer": "CDuwya_footer",
  "header": "CDuwya_header",
  "root": "CDuwya_root",
  "securityPracticesBanner": "CDuwya_securityPracticesBanner",
});
